import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  getUserLanguage(): string {
    return localStorage.getItem('language') || environment.language;
  }


  private languageCultureMap: { [key: string]: string } = {
  'en': 'en-GB', // English (United Kingdom)
  'sq': 'sq-AL'  // Albanian (Albania)
  };
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (environment.allowLanguageChange) {
    const language = this.getUserLanguage();

    const acceptLanguageHeader = this.languageCultureMap[language] || language;

    const clonedRequest = req.clone({
      setHeaders: {
        'Accept-Language': acceptLanguageHeader 
      }
    });

    return next.handle(clonedRequest);
    }

    return next.handle(req);
  }
}
